export default __webpack_public_path__ + "static/media/bb4.a51282a0.png";